
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { FView } from '@/core/FView';
import { DataType } from '@/core/data/DataType';
import { Common } from '@/core/Common';
import Selector from '@/components/Selector.vue';
import App from '@/App.vue';
import { EnterExitColoredRecord } from '@/core/data/sets/computed/EnterExitColoredRecord';
import TabEnterExit from '@/components/tabs/TabEnterExit.vue';

interface DateDescription {
    name: string;
    value: string;
}

@Component ({
  components: {
      Selector,
  },
})
export default class extends Vue {
    getAllDates(): DateDescription[] {
        return EnterExitColoredRecord.getAllDates().map(dt => { return {
            name: `<span style="color: ${ this.getColor(dt) }">${Common.FormatDate(dt)}</span>`,
            value: dt,
        }});
    }

    getAllPlaces() {
        return EnterExitColoredRecord.getAllPlaces();
    }

    getColor(dt: string) {
        return Common.IsWeekend(dt) ? "#C11" : "#111"
    }

    applyDates(dates: DateDescription[]) {
        (this.$parent as TabEnterExit).filteredDates = dates.flatMap(d => d.value);
    }

    applyPlaces(places: string[]) {
        (this.$parent as TabEnterExit).filteredPlaces = places;
    }

    onFilterError(err: string) {
        let app: Vue = this;
        do { app = app.$parent; }
        while (!(app instanceof App));
        app.showError(err);
    }
}
